<template>
    <v-form>
        <v-row>
            <v-col cols="12">
                <subcard>
                    <v-row dense>
                        <v-col cols="12" sm="9">
                            <v-text-field
                                    :disabled="disabled"
                                    hide-details
                                    v-model="item.name"
                                    :label="l('pages.cashboxes.properties.name')"
                                    :rules="[rules.required]"
                                    required
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-checkbox
                                    :disabled="disabled"
                                    hide-details
                                    v-model="item.packs_envelopes"
                                    :label="l('pages.cashboxes.properties.packs_envelopes')"
                            />
                        </v-col>
                    </v-row>
                </subcard>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
    import Subcard from '../../../Shared/Cards/Subcard'
    import NumberField from '../../../Shared/Forms/TextFields/NumberField'

    export default {
        name: "CashboxEditForm",
        inheritAttrs: false,
        components: {
            NumberField,
            Subcard,
       },
        props: {
            value: {
                required: false,
                type: Object,
                default: () => ({}),
            },
            disabled: {
                required: false,
                type: Boolean,
                default: false,
            }
        },
        data: vm => ({
            item: {},
            rules: {
                required: value => undefined !== value && '' !== value || vm.l('pages.cashboxes.validation.required')
            },
        }),
        watch: {
            value: {
                deep: true,
                immediate: true,
                handler(value) {
                    this.item = value
                },
            },
            location: {
                deep: true,
                handler(value) {
                    this.$emit('input', value)
                },
            },
        },
    }
</script>

